/*
 * @Author: hanjianyu
 * @Date: 2020-08-31 10:41:11
 * @LastEditTime: 2020-11-18 15:02:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */
import { getUser } from '@/services/utils'

export default{
  methods: {
    sendSensors (sensorid, attrs) {
      if (!sensorid) {
        return
      }
      let obj = {
        userAccountID: getUser().id,
        SaaSID: getUser().school_id
      }
      // 如果有多余的属性
      if (attrs) {
        for (let key in attrs) {
          if (!obj[key]) {
            obj[key] = attrs[key]
          }
        }
      }
      let dev = ''
      if (window.location.host === 'main.mofaxiao.com' || window.location.host === 'main.weclassroom.com') {
        dev = 'production'
      } else {
        dev = 'staging'
      }
      const prefix = dev === 'production' ? '' : dev + '_'
      sensorid = prefix + sensorid
      if (window.sensors) {
        window.sensors.track(sensorid, obj, () => {})
      }
    }
  }
}
